/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(
  body: defs.basics.CostItemMappingRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/list`, {
      method: "GET",

      data: body,
      ...options,
    }),
  );
}
